import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import logo from '../../assets/images/hogcloud-logo1.svg';
import { articleCategories, articles } from './articles';
import './index.css';

function Articles() {
  const { slug } = useParams();
  const selected = articles.find((article) => article.slug === slug);
  const [content, setContent] = useState('');
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setContent('');
    setFailed(false);
    if (!selected) return;
    const controller = new AbortController();
    fetch(selected.contentUrl, { signal: controller.signal })
      .then((response) => {
        if (!response.ok) throw new Error('Article unavailable');
        return response.text();
      })
      .then(setContent)
      .catch(() => { if (!controller.signal.aborted) setFailed(true); });
    return () => controller.abort();
  }, [selected]);

  if (slug) return (
    <div className="articles-page articles-detail">
      <Link className="articles-back" to="/articles">← All articles</Link>
      {selected ? <article className="articles-card">
        <header>
          <p className="articles-eyebrow">Hogcloud · {selected.category}</p>
          <h1>{selected.title}</h1>
          <time dateTime={selected.date}>{new Date(`${selected.date}T00:00:00`).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</time>
        </header>
        {failed ? <p role="alert">Unable to load this article. Please refresh to try again.</p> : content ?
          // Only trusted, repository-owned HTML is rendered here.
          <div className="articles-body" dangerouslySetInnerHTML={{ __html: content }} /> :
          <p role="status">Loading article…</p>}
      </article> : <h1>Article not found</h1>}
    </div>
  );

  return (
    <div className="articles-page">
      <header className="articles-hero">
        <img src={logo} alt="Hogcloud logo" width="240" />
        <div>
          <p className="articles-eyebrow">Explore. Learn. Create.</p>
          <h1>Hogcloud Articles and Learning</h1>
          <p>Articles, insights, and practical learning from Hogcloud.</p>
        </div>
      </header>
      <section className="articles-list" aria-label="Articles">
        {articles.length ? articles.map((article) => (
          <article className="articles-card" key={`${article.date}-${article.title}`}>
            <p className="articles-eyebrow">{article.category}</p>
            <time dateTime={article.date}>
              {new Date(`${article.date}T00:00:00`).toLocaleDateString('en-US', {
                year: 'numeric', month: 'long', day: 'numeric',
              })}
            </time>
            <h2><Link to={`/articles/${article.slug}`}>{article.title}</Link></h2>
            <p>{article.description}</p>
            <Link className="articles-read" to={`/articles/${article.slug}`}>Read article →</Link>
          </article>
        )) : (
          <div className="articles-card">
            <p className="articles-eyebrow">{articleCategories[0]} · Coming soon</p>
            <h2>Our first article is on the way</h2>
            <p>Check back soon for new articles and learning resources from Hogcloud.</p>
          </div>
        )}
      </section>
    </div>
  );
}

export default Articles;
